export default "__VITE_ASSET__2ec62a59__"